import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';

export const StyledKpiCard = styled.div.attrs({
  'data-pdf-block': 'true',
  'data-pdf-order': '5',
})`
  background: ${COLORS.WHITE};
  border: 1px solid ${COLORS.BRIGHT_GRAY};
  border-radius: 0.75rem;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  height: 100%;

  [data-pdf-exporting='true'] & {
    height: auto;
    min-height: 0;
  }
`;

export const StyledKpiTitle = styled.h3`
  margin: 0 0 0.15rem;
  ${pickThemeFontStyles('16', '22', 'SEMI_BOLD')};
`;

export const StyledKpiItem = styled.div`
  background: ${COLORS.BRIGHT_GRAY};
  border: none;
  border-radius: 0.5rem;
  padding: 0.65rem 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
`;

export const StyledKpiLabelRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0.5rem;
  min-width: 0;
`;

export const StyledKpiLabel = styled.div`
  ${pickThemeFontStyles('12', '16', 'NORMAL')};
  color: ${COLORS.GRAY_PRIMARY};
  min-width: 0;
`;

export const StyledKpiValue = styled.div`
  ${pickThemeFontStyles('18', '24', 'SEMI_BOLD')};
  color: ${COLORS.BLACK};
  min-width: 0;
  white-space: nowrap;
`;

export const StyledKpiHint = styled.div`
  ${pickThemeFontStyles('12', '16', 'NORMAL')};
  color: ${COLORS.GRAY_PRIMARY};
  margin-top: 0.15rem;
`;
